export enum LocalStorageKey {
  'TOKEN' = 'authToken',
  'EDGE_CONFIG_UPDATING' = 'edgeConfigUpdatingByUuid',
  'ACCOUNT_LOCKED' = 'lock',
}
